/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as AddressService from './service'
import { AddressPath, ICountry } from './model'

export const findAll = async (params?: any): Promise<{ body: ICountry[] }> => {
  const response = await AddressService.findAll(AddressPath.COUNTRIES, params)

  return response
}
